import { useTranslations } from '@vocab/react';
import {
  Inline,
  Button,
  IconThumb,
  useResponsiveValue,
} from 'braid-design-system';
import type { FC } from 'react';

import { BUCKETS } from 'src/stores/JobApplicationStore/types';

import translations from '../.vocab';
import type { JobApplicationCardProps } from '../JobApplicationCard';

export const NotSuitableAndShortlistButtons: FC<
  Pick<JobApplicationCardProps, 'changeStatus'> & {
    fullName: string;
    isFilterExpand: boolean;
  }
> = ({ fullName, changeStatus, isFilterExpand }) => {
  const { t } = useTranslations(translations);
  const responsiveValue = useResponsiveValue();
  const isMobile = responsiveValue({
    mobile: true,
    tablet: false,
    desktop: false,
  });
  const isTablet = responsiveValue({
    mobile: false,
    tablet: true,
    desktop: false,
  });

  const shouldShowIconView = isMobile || (isTablet && isFilterExpand);

  return (
    <Inline space="xsmall" alignY="center">
      <Button
        tone="neutral"
        variant="solid"
        size="small"
        aria-label={t('Move fullName to Not Suitable', {
          fullName,
        })}
        onClick={(e) => {
          e.stopPropagation();
          changeStatus(BUCKETS.NOT_SUITABLE);
        }}
        icon={shouldShowIconView ? undefined : <IconThumb direction="down" />}
      >
        {shouldShowIconView ? (
          <IconThumb direction="down" />
        ) : (
          t('Not Suitable')
        )}
      </Button>

      <Button
        tone="neutral"
        variant="solid"
        size="small"
        aria-label={t('Shortlist fullName', {
          fullName,
        })}
        onClick={(e) => {
          e.stopPropagation();
          changeStatus(BUCKETS.SHORTLIST);
        }}
        icon={shouldShowIconView ? undefined : <IconThumb direction="up" />}
      >
        {shouldShowIconView ? <IconThumb direction="up" /> : t('Shortlist')}
      </Button>
    </Inline>
  );
};
